<template>
  <!-- 选择地址弹出层 -->
  <van-popup
    v-model="showPicker"
    round
    position="bottom"
  >
    <div class="popup-box">
      <div class="title-box">
        <div>修改目的地</div>
        <van-icon
          name="clear"
          color="#E9E9E9"
          size="20"
          @click="close"
        />
      </div>
      <van-search
        v-model="searchKey"
        placeholder="请输入地名进行搜索"
        class="search-input"
        clearable
        @input="changeSearch"
      />
      <div class="address-box">
        <div
          class="address-item"
          :class="{active: activeIndex === index}"
          v-for="(item, index) in addressList"
          :key="index"
          @click="selectAddress(index)"
        >
          <div class="item-left">
            <div class="item-icon">
              <van-icon name="location" />
            </div>
            <div>
              <div class="item-name">{{ item.name }}</div>
              <div class="item-address">{{ item.pname || '' }}{{ item.cityname || '' }}{{ item.address }}</div>
            </div>
          </div>
          <div class="item-distance">
            {{ getDistance(item.location) }}
          </div>
        </div>
        <van-empty
          v-if="addressList.length === 0"
          image="search"
          description="请输入详细的省市地名进行搜索"
        />
      </div>
      <van-row>
        <van-col
          span="22"
          offset="1"
        >
          <van-button
            type="info"
            block
            :disabled="activeIndex < 0"
            @click="confirm"
          >确定</van-button>
        </van-col>
      </van-row>
    </div>
  </van-popup>
</template>

<script>
import {
  updateDestination
} from '@/common/apiGeneral.js';
import { debounce } from 'lodash';
export default {
  data() {
    return {
      searchKey: '',
      showPicker: false,
      placeSearch: null,
      addressList: [],
      activeIndex: -1,
      currentPosition: null,
      cityCode: '',
      taskStatus: '',
      taskNo: ''
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    open(currentPosition, taskNo, taskStatus) {
      this.currentPosition = currentPosition;
      this.taskNo = taskNo;
      this.taskStatus = taskStatus;
      if (this.currentPosition) {
        this.initMap();
      }
      this.initSearch();
      this.showPicker = true;
    },
    close() {
      this.showPicker = false;
      this.searchKey = '';
      this.addressList = [];
      this.activeIndex = -1;
    },
    confirm() {
      // 修改服务终点
      this.updateDestination();
    },
    initMap() {
      const _this = this;
      const geocoder = new AMap.Geocoder({
        radius: 10 // 范围，默认：500
      });
      geocoder.getAddress(new AMap.LngLat(this.currentPosition.longitude, this.currentPosition.latitude), (status, result) => {
        if (status === 'complete' && result.regeocode) {
          console.log(result);
          // 切换县区级到市级
          _this.cityCode = result.regeocode.addressComponent.adcode.slice(0, 4) + '00';
          console.log(_this.cityCode);
        } else {
          // log.error('根据经纬度查询地址失败')
          console.log('根据经纬度查询地址失败');
        }
      });
    },
    initSearch() {
      const _this = this;
      AMap.service(['AMap.PlaceSearch'], function() {
        _this.placeSearch = new AMap.PlaceSearch({
          pageSize: 30, // 单页显示结果条数
          pageIndex: 1, // 页码
          extensions: 'all',
          city: _this.cityCode, // 兴趣点城市
          citylimit: false
        });
      });
    },
    changeSearch: debounce(function(val) {
      if (this.placeSearch) {
        this.activeIndex = -1;
        const _this = this;
        this.placeSearch.search(val, (status, result) => {
          console.log(result, 'result');
          _this.addressList = result.poiList ? (result.poiList.pois || []) : [];
        });
      }
    }, 300),
    selectAddress(index) {
      this.activeIndex = index;
    },
    getDistance(location) {
      if (this.currentPosition) {
        const locationArr = [location.lng, location.lat];
        const currentPositionArr = [this.currentPosition.longitude, this.currentPosition.latitude];
        const distance = AMap.GeometryUtil.distance(locationArr, currentPositionArr);
        return `距您${(distance / 1000).toFixed(1)}km`;
      } else {
        return '';
      }
    },
    async updateDestination() {
      try {
        const selectedAddr = this.addressList[this.activeIndex];
        console.log(selectedAddr);
        const pcode = selectedAddr.pcode || `${selectedAddr.adcode.slice(0, 2)}0000`;
        const citycode = `${selectedAddr.adcode.slice(0, 4)}00`;
        const adcode = selectedAddr.adcode;

        const province = selectedAddr.pname || '';
        const city = selectedAddr.cityname || '';
        const address = selectedAddr.address || '';
        const name = selectedAddr.name || '';
        const destination = `${province}${city}${address}${name}`;
        await updateDestination({
          taskNo: this.taskNo,
          taskStatus: this.taskStatus,
          destination,
          province: pcode,
          city: citycode,
          area: adcode,
          longitude: selectedAddr.location.lng,
          latitude: selectedAddr.location.lat
        });
        this.$toast('修改成功');

        this.$emit('confirm');
        this.close();
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.popup-box{
  padding: 16px 8px 0;
}
.title-box{
  display: flex;
  justify-content: space-between;

  padding: 8px 12px;

  font-size: 16px;
}
.search-input{
  .van-search__content{
    border-radius: 8px;
    .van-cell{
      padding: 8px 8px 8px 0;
    }
  }
}
.address-box {
  overflow-y: auto;

  height: 45vh;
  .address-item{
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 16px 12px;

    letter-spacing: -0.38px;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;

    &.active{
      color: #1989fa;
      .item-icon,
      .item-left,
      .item-name,
      .item-address,
      .item-distance{
        color: #1989fa;
      }
    }

    .item-icon{
      margin-right: 12px;

      color: #B7BFC8;
    }

    .item-left{
      display: flex;
      align-items: center;

      margin-right: 12px;
    }

    .item-name{
      color: #3B3B3B;

      font-size: 15px;
      font-weight: 600;
    }

    .item-address{
      padding-top: 8px;

      color: #8D8D8D;

      font-size: 13px;
      font-weight: 400;
    }

    .item-distance{
      flex: 80px 0 0;

      text-align: right;

      color: #B6B6B6;

      font-size: 12px;
      font-weight: 400;
    }
  }
}
.van-row{
  padding: 10px 0;
}
</style>
